import { convertGeoCodeResultToAdressDetail } from 'features/map/mapUtils';
import { useEffect, useState } from 'react';
import { geocodeByLatLng } from 'react-google-places-autocomplete';
import { AddressDetailState } from 'schemas/addressDetailsStateSchema';
import { GeoPoint } from 'schemas/geoPointSchema';

const useAutoLocation = (enabled: boolean) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | undefined>(undefined);
  const [currentLocation, setCurrentLocation] = useState<GeoPoint | undefined>(
    undefined
  );
  const [currentAddress, setCurrentAddress] = useState<
    AddressDetailState | undefined
  >(undefined);

  const onError = (message: string) => {
    setIsLoading(false);
    setCurrentAddress(undefined);
    setError(message);
  };

  useEffect(() => {
    if (!enabled) {
      setIsLoading(false);
      setCurrentAddress(undefined);
      setCurrentLocation(undefined);
      setError(undefined);
    } else {
      setIsLoading(true);
      setCurrentAddress(undefined);
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const geoPoint = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          setError(undefined);
          setCurrentLocation(geoPoint);
          geocodeByLatLng(geoPoint)
            .then((result) => {
              const addressDetails = convertGeoCodeResultToAdressDetail(result);
              if (
                addressDetails &&
                addressDetails.postCode &&
                addressDetails.address
              ) {
                setCurrentAddress(addressDetails);
                setIsLoading(false);
              } else {
                console.warn(
                  `no correct address component : ${JSON.stringify(
                    addressDetails
                  )}`
                );
                onError('Unable to retrieve address details'); // TODO:
              }
            })
            .catch((e) => {
              console.warn('error with geoCode');
              onError(e as string);
            });
        },
        (errorLoc) => {
          console.warn(errorLoc);
          onError(errorLoc.message);
        }
      );
    }
  }, [enabled]);

  return { isLoading, error, currentLocation, currentAddress };
};

export default useAutoLocation;
